export default __webpack_public_path__ + "static/media/elevate.92656150.png";